import Avatar from "@imminently/decisively-ui/Avatar";
import type { AdapterDefinition } from "@/features/adapters/model/types";

const sizes = { sm: "h-5 w-5", md: "h-8 w-8", lg: "h-10 w-10" } as const;
const avatarSizes = { sm: "xs", md: "md", lg: "lg" } as const;

/** The adapter's product logo in a square, or a square avatar with the adapter's initials when it has no image. */
export const AdapterLogo = ({
  definition,
  size = "md",
}: {
  definition: Pick<AdapterDefinition, "name" | "image">;
  size?: keyof typeof sizes;
}) =>
  definition.image ? (
    <img
      src={definition.image}
      alt=""
      aria-hidden="true"
      className={`${sizes[size]} shrink-0 rounded-md object-contain`}
    />
  ) : (
    <Avatar shape="square" size={avatarSizes[size]} name={definition.name} aria-hidden="true" />
  );
